import React from 'react';
import {
  IEntityPermissionFieldsFragment,
  PermissionEntityType,
} from '../../../utils/apollo/graphqlSchema';
import { useScratchpadContext } from '../../Scratchpad/ScratchpadContext';
import {
  IEntityPermissionsWidgetState,
  prepareEntityRoleAssignmentInput,
} from '../utils';
import toastMessage from '../../../utils/toastMessage';
import EntityPermissionsWidgetPopover from '../EntityPermissionsWidgetPopover';

interface IProps {
  scratchpadId: string;
  permission: IEntityPermissionFieldsFragment;
}

const ScratchpadEntityPermissionsWidgetPopover = ({
  scratchpadId,
  permission,
}: IProps) => {
  const { editScratchpadPermissions } = useScratchpadContext();

  const handleSubmit = async (formData: IEntityPermissionsWidgetState) => {
    const success = await editScratchpadPermissions({
      entityId: scratchpadId,
      entityType: PermissionEntityType.Scratchpad,
      defaultPublicRole: formData.defaultPublicRole,
      roleAssignments: prepareEntityRoleAssignmentInput(formData.users),
    });

    if (success) {
      toastMessage({
        message: 'User access for the scratchpad is updated.',
        type: 'info',
      });
    }
  };

  return (
    <EntityPermissionsWidgetPopover
      permission={permission}
      onSubmit={handleSubmit}
      title="Share this Scratchpad"
      showPublicRole={false}
      disableRoleChange={true}
    />
  );
};

export default ScratchpadEntityPermissionsWidgetPopover;
